var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-page-header',{attrs:{"content":"详情"},on:{"back":_vm.goBack}}),_c('div',{staticClass:"dailyDetails"},[_c('myTable',{attrs:{"loading":_vm.loading,"tableData":_vm.tableData,"tableHeader":_vm.tableHeader}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }